import React from "react";
import ContentLoader from "react-content-loader";

export const BarChart = (props) => {
  return (
    <ContentLoader 
      viewBox="0 0 800 400" 
      height={400} 
      width="100%" 
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      {/* First Row - Four Blocks */}
      <rect x="20"  y="20"  rx="8" ry="8" width="170" height="80" /> {/* Block 1 */}
      <rect x="210" y="20"  rx="8" ry="8" width="170" height="80" /> {/* Block 2 */}
      <rect x="400" y="20"  rx="8" ry="8" width="170" height="80" /> {/* Block 3 */}
      <rect x="590" y="20"  rx="8" ry="8" width="170" height="80" /> {/* Block 4 */}

      {/* Second Row - Bar Chart (Left Half) */}
      <rect x="40"  y="130" rx="4" ry="4" width="25" height="120" />
      <rect x="80"  y="150" rx="4" ry="4" width="25" height="100" />
      <rect x="120" y="110" rx="4" ry="4" width="25" height="140" />
      <rect x="160" y="170" rx="4" ry="4" width="25" height="80" />
      <rect x="200" y="140" rx="4" ry="4" width="25" height="110" />
      <rect x="240" y="160" rx="4" ry="4" width="25" height="90" />
      <rect x="280" y="120" rx="4" ry="4" width="25" height="130" />

      {/* Second Row - Pie Chart (Right Half) */}
      <circle cx="640" cy="200" r="60" />
      <circle cx="640" cy="200" r="40" />
      <circle cx="640" cy="200" r="20" />
    </ContentLoader>
    
  );
};
